import InsertPhotoSharpIcon from "@mui/icons-material/InsertPhotoSharp";
import IconButton from "@mui/material/IconButton";
import { BubbleMenu as TipTapBubbleMenu } from "@tiptap/react";
import { styled } from "@mui/material/styles";

const StyledIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "$isActive",
})(({ theme, $isActive }) => ({
  color: $isActive ? theme.palette_custom.darkBlue : "#37352f80",
  "&:hover": {
    color: theme.palette_custom.darkBlue,
    backgroundColor: "inherit",
  },
}));

const StyledTipTapBubbleMenu = styled(TipTapBubbleMenu)(({ theme }) => ({
  backgroundColor: theme.palette_custom.white,
  width: "100%",
  border: `0.5px solid ${theme.palette_custom.darkBlue}`,
}));

const BubbleMenu = ({ editor }) => {
  return (
    <StyledTipTapBubbleMenu
      editor={editor}
      tippyOptions={{ duration: 100 }}
      shouldShow={({ editor }) => {
        if (editor.isActive("SizableImage")) return true;
        return false;
      }}
    >
      <StyledIconButton
        aria-label="small"
        onClick={() => editor.chain().focus().small().run()}
        $isActive={editor.isActive("SizableImage", { width: "25%" })}
      >
        <InsertPhotoSharpIcon sx={{ scale: "0.68" }} />
      </StyledIconButton>
      <StyledIconButton
        aria-label="medium"
        onClick={() => editor.chain().focus().medium().run()}
        $isActive={editor.isActive("SizableImage", { width: "50%" })}
      >
        <InsertPhotoSharpIcon sx={{ scale: "0.75" }} />
      </StyledIconButton>
      <StyledIconButton
        aria-label="large"
        onClick={() => editor.chain().focus().large().run()}
        $isActive={editor.isActive("SizableImage", { width: "75%" })}
      >
        <InsertPhotoSharpIcon sx={{ scale: "0.82" }} />
      </StyledIconButton>
    </StyledTipTapBubbleMenu>
  );
};

export default BubbleMenu;
